<div class="rolodex" id="rolodex" >
  <div *ngFor="let aItem of theItems; let i = index">
    <div class="btn btn-default ColortuneTile"
         (click)="onCardClick(aItem, i, $event)"
         [class.focused]="focusCard === aItem"
         [class.transitioning]="isTransitioning"
         [style.transform]="focusCard === aItem ? 'translate3d(0.0,0.0 ,0.0) scale(0.7)' : getRolodexCardTransform(i)"
         [style.zIndex]="focusCard === aItem ? 10000 : getRolodexCardZIndex(i)">
      <img class="ItemImage" src="{{aItem.iconURL}}">
      <div class="ItemTextBlock">
        <div class="ItemTitle">{{aItem.name}}</div>
        <p class="ItemDescription"
           [class.scrollable]="focusCard === aItem"
           [innerText]="aItem.description"></p>
        <a *ngIf="aItem.webReference && focusCard === aItem"
           [href]="aItem.webReference"
           target="_blank"
           class="PromenadeLogoLink"
           (click)="$event.stopPropagation()">
          <img src="assets/images/DorisOilPromenadeCroppedColorAdjustedWeb.png"
               alt="Open in myPromenade app"
               class="PromenadeLogo" />
        </a>
      </div>
    </div>
  </div>
  <span *ngIf="rolodexDebugger">
    <span>offset={{offset}}</span>
    <span>velocity={{velocity}}</span>
    <span>force={{force}}</span>
    <span>forceTouch={{forceTouch}}</span>
    <span>forceTouchVelocity={{forceTouchVelocity}}</span>
    <span data-ng-hide="touched">Drag and Tap</span>
    <span data-ng-show="touched">-----xx-----</span>
  </span>
</div>
